// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mt4-","name":"styles_name__3S3FW","phone":"styles_phone__3cj8e"};